import styled, { css } from "styled-components";
import { breakpoints } from "themes/breakpoints";
import { MENU_NAV_HEIGHT } from "utils/constants";

export const containerStyle = (backgroundSrc?: string) => css`
  height: calc(100vh - ${MENU_NAV_HEIGHT}px);
  ${backgroundSrc
    ? `background-image: url(${process.env.REACT_APP_BASE_RELATIVE_ROUTES}/assets/${backgroundSrc});`
    : `background: linear-gradient(#303387, #1f2055);`}
  background-size: cover;
  width: 100%;
`;

export const BannerImageContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;

  @keyframes tiltLeft {
    to {
      opacity: 1;
      top: 15%;
      transform: rotate(0deg);
    }
  }

  @keyframes tiltRight {
    to {
      opacity: 1;
      top: 20%;
      transform: rotate(-5deg);
    }
  }

  @media (max-width: ${breakpoints.sm}) {
    @keyframes tiltLeft {
      to {
        opacity: 1;
        top: 25%;
        transform: rotate(0deg);
      }
    }

    @keyframes tiltRight {
      to {
        opacity: 1;
        top: 30%;
        transform: rotate(-5deg);
      }
    }
  }

  & img {
    position: absolute;
    max-height: 100%;
  }

  & .phone {
    width: 40%;
    height: auto;

    &.left {
      z-index: 1;
      opacity: 0;
      top: 50%;
      left: 15%;
      transform: rotate(20deg);
      animation: tiltLeft 2s ease-in-out forwards;
    }

    &.right {
      opacity: 0;
      top: 50%;
      right: 20%;
      transform: rotate(-17deg);
      animation: tiltRight 2s ease-in-out forwards;
    }
  }
`;
